export class AssesmentQuestionOption {
	answer: string;
	isCorrectAnswer?: boolean;
	translations: Record<string, string>;
}
